/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface TicketScanRequest
 */
export interface TicketScanRequest {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof TicketScanRequest
     */
    eventId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof TicketScanRequest
     */
    code: string;
}

/**
 * Check if a given object implements the TicketScanRequest interface.
 */
export function instanceOfTicketScanRequest(value: object): value is TicketScanRequest {
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function TicketScanRequestFromJSON(json: any): TicketScanRequest {
    return TicketScanRequestFromJSONTyped(json, false);
}

export function TicketScanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketScanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['eventId']),
        'code': json['code'],
    };
}

export function TicketScanRequestToJSON(json: any): TicketScanRequest {
    return TicketScanRequestToJSONTyped(json, false);
}

export function TicketScanRequestToJSONTyped(value?: TicketScanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['eventId']),
        'code': value['code'],
    };
}

